import "@isbj-redesign/styles/portal.css"
import { h, render } from "preact"
import App from "./App"
import "./styles.css"

render(<App />, window.document.body)
